import repositories from '..';

const resource = '/integration/screen-groups';

export default {
  getInitData: () => repositories.get(`${resource}/data/init`),
};
